import api from './api';

export const getEstadosList = async () => {
  try {
    const { data } = await api.get('estado/list?NumeroRegistros=28');
    return data;
  } catch (error) {
    return { error };
  }
};
